
export const DOLLS_SUBCATEGORIES = ['TeddyDoll', 'Boudoir', 'Hinged', 'Textile', 'Custom']